export const gift = {
    gift_title: 'Tu evolución',
    gift_points_1 : 'Tienes',
    gift_points_2 : 'puntos',
    gift_find_gift: 'Encuentra mi regalo',
    milestone: "Hito",
    milestone_passed: "La fecha límite del cuestionario ya ha pasado.",
    milestone_available: "El cuestionario estuvo disponible durante este período.",
    milestone_soon: "Este cuestionario estará disponible en {{count}} día{{plural}}.",
    milestone_reminder: "Recibirá un recordatorio por {{methods}}.",
}
